import React, {useState, useEffect, useContext} from 'react';
import {SiteHeader} from '@homeaway/react-site-header';
import {useStaticQuery, graphql} from 'gatsby';
import {SiteConfigContext} from '../context/SiteConfigContext';
import './Header.less';

const Header = () => {
    const {sitename} = useContext(SiteConfigContext);
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);

    const {header} = useStaticQuery(graphql`
        query {
            header {
                data
            }
        }
    `);

    const data = JSON.parse(header.data);

    return isClient ? (
        <SiteHeader
            {...data}
            siteName={sitename}
            isInverse={data.features['theme-inverse']}
            mobileBreakpoint={1200}
            login={false}
            withoutCountryLanguageSelector
        />
    ) : (
        <div className="site-header--wrapper">
            <div className="site-header border-border-color">
                <div className="site-header-logo">
                    <a
                        href={data.logo.link}
                        className="site-header-logo__link flex-item"
                    >
                        <img
                            src={data.logo.image}
                            className="site-header-logo__img Header-BG img-responsive"
                            alt={data.logo.altText}
                            itemProp="logo"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Header;
